module.exports = __webpack_public_path__ + "media/en_us_s2_Jodie.1c864404.oga";